export const VOICE_GUIDED_FIELD_TYPE = Object.freeze({
  TEXT: "text",
  TEXTAREA: "textarea",
  DROPDOWN: "dropdown",
  NUMBER: "number",
  DATE: "date",
  ROUTED_CONTACT: "routedContact",
});

/**
 * @typedef {import("./guidedConfirmationMode").typeof GUIDED_CONFIRMATION_MODE[keyof typeof GUIDED_CONFIRMATION_MODE]} GuidedConfirmationMode
 */

/**
 * @typedef {object} VoiceGuidedFormStep
 * @property {string} fieldId - Target field id, or virtual id for composite steps.
 * @property {string} prompt - Ashley spoken prompt for this step.
 * @property {string} [type] - {@link VOICE_GUIDED_FIELD_TYPE}
 * @property {GuidedConfirmationMode} [confirmationMode] - How Ashley confirms populated values.
 * @property {boolean} [autoOpenDropdown] - Best-effort native select open after prompt.
 * @property {boolean} [unmatchedRecovery] - Offer recovery when voice cannot match dropdown options.
 * @property {string} [highlightFieldId] - DOM highlight target when fieldId is virtual.
 * @property {string} [emailFieldId] - For routedContact steps.
 * @property {string} [phoneFieldId] - For routedContact steps.
 */

/**
 * @typedef {object} VoiceGuidedFormSchema
 * @property {string} formId - Stable identifier for this form (e.g. create_project).
 * @property {GuidedConfirmationMode} [defaultConfirmationMode] - Default per-step confirmation behavior.
 * @property {VoiceGuidedFormStep[]} steps - Ordered guided steps.
 */

/**
 * @typedef {object} VoiceGuidedFieldBinding
 * @property {() => string} getValue
 * @property {(value: string) => void} setValue
 * @property {string} [type] - {@link VOICE_GUIDED_FIELD_TYPE}
 * @property {{ value: string, label: string }[]} [options] - Dropdown options.
 */
